// /src/components/main/bottom.jsx (or wherever this footer lives)
import React from "react";
import { Link } from "react-router-dom";
import "./bottom.css";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const aamLogo = `https://cosacademyassets.s3.us-east-2.amazonaws.com/IMG_4959.webp`;

  return (
    <footer className="ct-footer" role="contentinfo">
      {/* Thin gradient divider */}
      <div className="ct-footer-bar" aria-hidden="true" />

      <div className="ct-footer-inner">
        {/* Brand / short value prop */}
        <section className="ct-foot-col ct-foot-brand">
          <div className="ct-brand-lock">
            <span className="ct-brand">COSMET</span>
            <span className="ct-brand-ink">INK</span>
            <span className="ct-brand">&nbsp;ACADEMY</span>
          </div>
          <p className="ct-brand-copy">
            East Coast&apos;s Premier Accredited Permanent Cosmetics Training
          </p>

          {/* Accreditation */}
          <div className="ct-accredit">
            {aamLogo ? (
              <img className="ct-aam" src={aamLogo} alt="AAM Accredited" />
            ) : (
              <div className="ct-aam-fallback" aria-label="AAM Accredited">
                AAM
              </div>
            )}
            <div className="ct-accredit-copy">
              American Academy of Micropigmentation<br />
              Accredited Training
            </div>
          </div>
        </section>

        {/* Programs / Courses */}
        <nav className="ct-foot-col" aria-label="Programs & Courses">
          <h4 className="ct-head">Programs / Courses</h4>

          {/* Fundamentals */}
          <div className="ct-subgroup">
            <div className="ct-subhead">Fundamental Courses</div>
            <ul className="ct-list">
              <li>
                <Link to="/courses/nano" className="ct-link">
                  Full Nano Brows <span className="ct-meta">| 3 Days</span>
                </Link>
              </li>
              <li>
                <Link to="/courses/nanocombo" className="ct-link">
                  Nano Combo Brows <span className="ct-meta">| 3 Days</span>
                </Link>
              </li>
              <li>
                <Link to="/courses/ombre" className="ct-link">
                  Ombré Brows <span className="ct-meta">| 2 Days</span>
                </Link>
              </li>
              <li>
                <Link to="/courses/lips" className="ct-link">
                  Lip Blush <span className="ct-meta">| 2 Days</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Advanced */}
          <div className="ct-subgroup">
            <div className="ct-subhead">Advanced Courses</div>
            <ul className="ct-list">
              <li>
                <Link to="/courses/lash-enhancement" className="ct-link">
                  Lash Enhancement (Tattoo){" "}
                  <span className="ct-meta">| 1-on-1 Mentorship</span>
                </Link>
              </li>
            </ul>
          </div>
        </nav>

        {/* About */}
        <nav className="ct-foot-col" aria-label="About">
          <h4 className="ct-head">About</h4>
          <ul className="ct-list">
            <li>
              <Link to="/history" className="ct-link">Vision &amp; History</Link>
            </li>
            <li>
              <Link to="/apprenticeship" className="ct-link">Apprenticeship</Link>
            </li>
            <li>
              <Link to="/trainers" className="ct-link">Meet Our Master Trainers</Link>
            </li>
            <li>
              <a
                className="ct-link"
                href="https://www.google.com/search?q=cosmetink#lrd=0x89c443557b11e64d:0x601c04db1170f5b6,1,,,"
                target="_blank"
                rel="noopener noreferrer"
              >
                Reviews on Google ↗
              </a>
            </li>
          </ul>
        </nav>

        {/* Contact */}
        <section className="ct-foot-col" aria-label="Contact">
          <h4 className="ct-head">Contact</h4>
          <address className="ct-address">
            COSMETINK® Headquarters<br />
            3859 Nazareth Pike<br />
            Bethlehem, PA 18020
          </address>
          <br />
          <a className="ct-mail" href="mailto:cosmetinkbeauty@gmail.com">
            cosmetinkbeauty@gmail.com
          </a>
          <br /><br />
          <div className="ct-social">
            <a
              className="ct-social-link"
              href="https://instagram.com/cosmetinkbeauty"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram ↗
            </a>
            <a
              className="ct-social-link"
              href="https://www.youtube.com/channel/UCHBHoB48jZLahe7xSTfDKMw"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube ↗
            </a>
          </div>
        </section>
      </div>

      {/* Bottom line */}
      <div className="ct-legal">
        <div className="ct-legal-inner">
          <span>© {year} COSMETINK, COSMETINK ACADEMY. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
